import { render } from "./PasswordSetting.vue?vue&type=template&id=255cf49d&scoped=true"
import script from "./PasswordSetting.vue?vue&type=script&lang=js"
export * from "./PasswordSetting.vue?vue&type=script&lang=js"

import "./PasswordSetting.vue?vue&type=style&index=0&id=255cf49d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-255cf49d"

export default script